import { getToFixed2Number } from 'utilities'

export const parseMilliseconds = (milliseconds: number): { value: number, label: 'hours' | 'minutes' | 'seconds' } => {
  if (!milliseconds) {
    return {
      label: 'seconds',
      value: 0
    }
  }

  const msPerSecond = 1000
  const msPerMinute = msPerSecond * 60
  const msPerHour = msPerMinute * 60
  const hours = milliseconds / msPerHour

  if (hours > 1) {
    return {
      label: 'hours',
      value: getToFixed2Number(hours)
    }
  }

  const minutes = milliseconds / msPerMinute
  if (minutes > 1) {
    return {
      label: 'minutes',
      value: getToFixed2Number(minutes)
    }
  }

  const seconds = Math.floor(milliseconds / msPerSecond)
  return {
    label: 'seconds',
    value: seconds
  }
}
